<script>
    // Bindings
    export let text;
    export let title;
    export let direction = "left";
    let view = false;

</script>

<div class="toolpop-slot" on:touchstart={() => view = !view} on:mouseover={() =>  view = true} on:mouseout={() => view = false}>
    <p class="toolpop-title">{title}<slot><span class="pop-indicator">...</span></slot></p>
</div>

<div class="toolpop">
    <div class="toolpop-content {direction}">
        <p class="toolpop-container {view ? 'show' : 'hide'}" on:touchstart={() => view = false}>{text}</p>
    </div>

    
</div>


<style lang="scss">
    .toolpop-content {
        display: inline-block;
        position: relative;
        .toolpop-container {
            font-size: 1em;
            font-weight: 400;
            text-align: left;
            position: absolute;
            top: 0;
            width: 300px;
            height: auto;
            background: color('white');
            padding: 1rem;
            z-index: 100;
            transition: transform .2s;
            @include shadow-variant(.2rem);

            &.hide {
                visibility: hidden;            
            }
            &.show { 
                visibility: visible;
                
                
            }
        }
        &.left {
            .toolpop-container {
                transform: translate(-50%, -115%);
                -webkit-transform: translate(-50%, -115%);
            }
        }

        &.right {
            .toolpop-container {
                transform: translate(50%, -115%);
            }
        }
        &.top {
            .toolpop-container {
                transform: translate(0, -115%);
            }
        }
        &.bottom {
            .toolpop-container {
                transform: translate(0, -5%);
            }
        }

        &.bottom.left {
            .toolpop-container {
                transform: translate(-50%, -5%);
            }
        }
        &.bottom.right {
            .toolpop-container {
                transform: translate(0px, -10px);
                //@include desktop{
                //    transform: translate(0px, -24px);
                //}
            }
        }
    }

.toolpop-slot {
    width: fit-content;
}
    .toolpop-title {
        margin: 0;
        cursor: pointer;
    }

</style>